import React from 'react';
import './term.scss';

const Privacy = () => {
  return (
    <div className="term-parent parent">
      <div className="term-cont cont">
        <div className="term-conts">
          <h1>Privacy Policy</h1>
        </div>

        <div className="term-cont2">
          <h2>Introduction</h2>
          <p>At Gandhi Travels, we value your privacy. This Privacy Policy explains how we collect, use, and protect your information when you visit our website or use our services.</p>

          <h2>Information Collection</h2>
          <p>We collect personal information that you provide to us directly through forms on our website, such as your name, email address, phone number, and other details required for providing our services.</p>

          <h2>Use of Information</h2>
          <p>The information we collect is used to provide and improve our services, respond to inquiries, process bookings, and send important updates regarding our services.</p>

          <h2>Data Protection</h2>
          <p>We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of data transmission over the internet is completely secure.</p>

          <h2>Cookies</h2>
          <p>We use cookies to enhance your browsing experience and improve the functionality of our website. Cookies allow us to remember your preferences and track your usage of the website.</p>

          <h2>Third-Party Links</h2>
          <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or the content of these third-party websites.</p>

          <h2>Changes to This Policy</h2>
          <p>We reserve the right to update or modify this Privacy Policy at any time. We encourage you to review this page regularly for any changes.</p>

          <h2>Contact Information</h2>
          <p>If you have any questions about our privacy policy or how your information is handled, please contact us at:</p>
          <p>
            Email:<a href="mailto:gandhi26@gmail.com">gandhi26@gmail.com</a>
          </p>
          <p>
            Phone: <a href="tel:+918308988188">Call Us: +91 83089 88188</a>
          </p>
          <p>
           Website: <a href="https://gandhitravels.co.in/" target="_blank" rel="noopener noreferrer">https://gandhitravels.co.in/</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
